import script from "./BaseNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseNav.vue?vue&type=script&setup=true&lang=js"

import "./BaseNav.vue?vue&type=style&index=0&id=3ce03362&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce03362"]])

export default __exports__